/* The Bright Cub — global.js
   Vanilla JS. No dependencies. Progressive enhancement. */
(function () {
  'use strict';

  var on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };
  var qs = function (s, c) { return (c || document).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ----------------------------------------------------------------
     Scroll lock helpers
  ---------------------------------------------------------------- */
  function lockScroll() { document.body.style.overflow = 'hidden'; }
  function unlockScroll() {
    if (!document.querySelector('.is-open.cart-drawer, .is-open.mobile-menu, .is-open.search-modal, .is-open.popup')) {
      document.body.style.overflow = '';
    }
  }

  /* ----------------------------------------------------------------
     Cart drawer + AJAX cart (Section Rendering API)
  ---------------------------------------------------------------- */
  var cartDrawer = qs('#CartDrawer');
  var overlay = qs('#DrawerOverlay');

  function openDrawer(el) { if (!el) return; el.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); lockScroll(); }
  function closeDrawer(el) { if (!el) return; el.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); unlockScroll(); }

  function openCart() {
    if (cartDrawer) { openDrawer(cartDrawer); }
    else { window.location.href = '/cart'; }
  }

  on(qs('#CartToggle'), 'click', function (e) { e.preventDefault(); openCart(); });
  on(overlay, 'click', function () {
    closeDrawer(cartDrawer);
    closeDrawer(qs('#MobileMenu'));
  });
  qsa('[data-cart-close]').forEach(function (b) { on(b, 'click', function () { closeDrawer(cartDrawer); }); });

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function refreshDrawer(sections) {
    if (!cartDrawer) return;
    var html = sections && sections['cart-drawer'];
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('#CartDrawerContents');
    var current = qs('#CartDrawerContents');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    bindCartLineEvents();
  }

  function addToCart(form, button) {
    var formData = new FormData(form);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    var original = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.innerHTML = 'Adding…'; }

    fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { throw new Error(data.description || 'Could not add to cart'); }
        if (button) { button.innerHTML = '✓ Added!'; }
        refreshDrawer(data.sections);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart) updateCartCount(cart.item_count);
        openCart();
      })
      .catch(function (err) { if (button) button.innerHTML = original; alert(err.message); })
      .finally(function () {
        if (button) setTimeout(function () { button.disabled = false; button.innerHTML = original; }, 1200);
      });
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (cart.sections) refreshDrawer(cart.sections);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  function bindCartLineEvents() {
    qsa('[data-line-plus]').forEach(function (b) {
      on(b, 'click', function () { changeLine(parseInt(b.dataset.line, 10), parseInt(b.dataset.qty, 10) + 1); });
    });
    qsa('[data-line-minus]').forEach(function (b) {
      on(b, 'click', function () { changeLine(parseInt(b.dataset.line, 10), Math.max(0, parseInt(b.dataset.qty, 10) - 1)); });
    });
    qsa('[data-line-remove]').forEach(function (b) {
      on(b, 'click', function () { changeLine(parseInt(b.dataset.line, 10), 0); });
    });
  }
  bindCartLineEvents();

  /* Intercept all product forms (cards + product page) */
  qsa('form[action*="/cart/add"]').forEach(function (form) {
    on(form, 'submit', function (e) {
      e.preventDefault();
      addToCart(form, form.querySelector('[type="submit"]'));
    });
  });

  /* ----------------------------------------------------------------
     Search modal + predictive search
  ---------------------------------------------------------------- */
  var searchModal = qs('#SearchModal');
  function openSearch() { if (searchModal) { searchModal.classList.add('is-open'); lockScroll(); var i = qs('#SearchInput'); if (i) setTimeout(function () { i.focus(); }, 100); } }
  function closeSearch() { if (searchModal) { searchModal.classList.remove('is-open'); unlockScroll(); } }
  qsa('[data-search-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); openSearch(); }); });
  qsa('[data-search-close]').forEach(function (b) { on(b, 'click', closeSearch); });

  var searchInput = qs('#SearchInput');
  var searchResults = qs('#SearchResults');
  var searchTimer;
  if (searchInput && searchResults && searchInput.dataset.predictive === 'true') {
    on(searchInput, 'input', function () {
      clearTimeout(searchTimer);
      var term = searchInput.value.trim();
      if (term.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { searchResults.innerHTML = '<p class="predictive__heading">No matches yet. Try a different word.</p>'; return; }
            var html = '<p class="predictive__heading">Products</p>';
            products.forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '<div style="width:52px;height:52px;border-radius:10px;background:var(--color-cream)"></div>';
              html += '<a class="predictive__item" href="' + p.url + '">' + img +
                '<span style="flex:1"><span class="title">' + p.title + '</span></span>' +
                '<span class="price__now">' + p.price + '</span></a>';
            });
            html += '<a class="link-arrow" style="margin:14px 6px 4px" href="/search?q=' + encodeURIComponent(term) + '">View all results</a>';
            searchResults.innerHTML = html;
          });
      }, 220);
    });
  }

  /* ----------------------------------------------------------------
     Mobile menu
  ---------------------------------------------------------------- */
  var mobileMenu = qs('#MobileMenu');
  on(qs('#MenuToggle'), 'click', function () { openDrawer(mobileMenu); });
  qsa('[data-menu-close]').forEach(function (b) { on(b, 'click', function () { closeDrawer(mobileMenu); }); });

  /* ----------------------------------------------------------------
     Global Escape key
  ---------------------------------------------------------------- */
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer(cartDrawer); closeDrawer(mobileMenu); closeSearch();
      var p = qs('#NewsletterPopup'); if (p) p.classList.remove('is-open');
      unlockScroll();
    }
  });

  /* ----------------------------------------------------------------
     Newsletter popup (timed + exit intent, dismiss persisted)
  ---------------------------------------------------------------- */
  var popup = qs('#NewsletterPopup');
  if (popup) {
    var KEY = 'tbc_popup_seen';
    var seen = false;
    try { seen = localStorage.getItem(KEY) === '1'; } catch (e) {}
    var delay = parseInt(popup.dataset.delay || '4', 10) * 1000;
    function showPopup() {
      if (seen || popup.classList.contains('is-open')) return;
      popup.classList.add('is-open'); lockScroll();
      seen = true;
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    }
    function hidePopup() { popup.classList.remove('is-open'); unlockScroll(); }
    if (!seen) {
      setTimeout(showPopup, delay);
      document.addEventListener('mouseout', function (e) {
        if (e.clientY <= 0 && !e.relatedTarget) showPopup();
      });
    }
    qsa('[data-popup-close]').forEach(function (b) { on(b, 'click', hidePopup); });
    on(qs('#NewsletterPopupOverlay'), 'click', hidePopup);
  }

  /* ----------------------------------------------------------------
     Wishlist (localStorage)
  ---------------------------------------------------------------- */
  function getWishlist() { try { return JSON.parse(localStorage.getItem('tbc_wishlist') || '[]'); } catch (e) { return []; } }
  function setWishlist(a) { try { localStorage.setItem('tbc_wishlist', JSON.stringify(a)); } catch (e) {} }
  function syncWishlist() {
    var list = getWishlist();
    qsa('[data-wishlist]').forEach(function (b) {
      var id = b.dataset.wishlist;
      if (list.indexOf(id) !== -1) b.classList.add('is-active');
      var c = qs('[data-wishlist-count]');
      if (c) c.textContent = list.length;
    });
  }
  qsa('[data-wishlist]').forEach(function (b) {
    on(b, 'click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var id = b.dataset.wishlist; var list = getWishlist(); var i = list.indexOf(id);
      if (i === -1) { list.push(id); b.classList.add('is-active'); } else { list.splice(i, 1); b.classList.remove('is-active'); }
      setWishlist(list); syncWishlist();
    });
  });
  syncWishlist();

  /* ----------------------------------------------------------------
     Scroll reveal
  ---------------------------------------------------------------- */
  if ('IntersectionObserver' in window && !document.body.classList.contains('no-anim')) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    qsa('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    qsa('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ----------------------------------------------------------------
     Product page: gallery, zoom, sticky ATC, accordion, variants
  ---------------------------------------------------------------- */
  // Gallery thumbnails
  var galleryMain = qs('#GalleryMain');
  qsa('[data-thumb]').forEach(function (t) {
    on(t, 'click', function () {
      if (!galleryMain) return;
      var img = galleryMain.querySelector('img');
      if (img) { img.src = t.dataset.full; img.srcset = ''; }
      qsa('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });
  // Image zoom
  if (galleryMain) {
    on(galleryMain, 'click', function () { galleryMain.classList.toggle('is-zoomed'); });
    on(galleryMain, 'mousemove', function (e) {
      if (!galleryMain.classList.contains('is-zoomed')) return;
      var r = galleryMain.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      var img = galleryMain.querySelector('img');
      if (img) img.style.transformOrigin = x + '% ' + y + '%';
    });
  }

  // Sticky add-to-cart
  var stickyAtc = qs('#StickyAtc');
  var atcAnchor = qs('#AtcAnchor');
  if (stickyAtc && atcAnchor && 'IntersectionObserver' in window) {
    var sObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { stickyAtc.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    sObs.observe(atcAnchor);
  }
  on(qs('#StickyAtcButton'), 'click', function () {
    var mainBtn = qs('#ProductForm [type="submit"]');
    if (mainBtn) mainBtn.click();
  });

  // Accordion
  qsa('.accordion__trigger').forEach(function (t) {
    on(t, 'click', function () {
      var expanded = t.getAttribute('aria-expanded') === 'true';
      var panel = t.nextElementSibling;
      t.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.style.maxHeight = expanded ? '0px' : panel.scrollHeight + 'px';
    });
  });

  // Quantity steppers on product page
  qsa('[data-qty-stepper]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    on(wrap.querySelector('[data-qty-down]'), 'click', function () { input.value = Math.max(1, parseInt(input.value, 10) - 1); });
    on(wrap.querySelector('[data-qty-up]'), 'click', function () { input.value = parseInt(input.value, 10) + 1; });
  });

  /* ----------------------------------------------------------------
     Recently viewed (localStorage), used on product page
  ---------------------------------------------------------------- */
  var rvData = qs('#RecentlyViewedData');
  if (rvData) {
    try {
      var current = JSON.parse(rvData.textContent);
      var key = 'tbc_recently_viewed';
      var list = JSON.parse(localStorage.getItem(key) || '[]');
      list = list.filter(function (h) { return h !== current.handle; });
      list.unshift(current.handle);
      list = list.slice(0, 8);
      localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {}
  }
})();
/* === BRIGHT CUB — ADD TO CART BUTTON FEEDBACK === */
(function () {
  var atcBtn = document.getElementById('AtcButton');
  if (!atcBtn) return;

  atcBtn.addEventListener('click', function () {
    var btn = this;

    // Wait a moment for Shopify to process the add
    setTimeout(function () {
      btn.classList.add('is-added');

      // Reset after 2.5 seconds
      setTimeout(function () {
        btn.classList.remove('is-added');
      }, 2500);
    }, 300);
  });
})();
// === BRIGHT CUB — CART ICON BOUNCE ===
document.addEventListener('cart:updated', function () {
  const cartIcon = document.querySelector('.header__icon--cart svg, .cart-icon-bubble');
  if (!cartIcon) return;
  cartIcon.classList.add('bounce');
  cartIcon.addEventListener('animationend', function () {
    cartIcon.classList.remove('bounce');
  }, { once: true });
});

